<template>
    <div >
        <span class="icon-timeline  " v-if="from=='folder'">
            <button class="button outline deletebtn tooltip" data-tooltip="Eliminar nota"  @click="borrar">
                <font-awesome-icon  icon="times" />
            </button>
         </span>
        <span class="icon-timeline">
            <svg
                class="svgFB"
                width="30px"
                height="30px"
                viewBox="0 0 24 24"
                v-if="item.entrada == 'FB'"
            >
                <path
                d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"
                />
            </svg>
            <svg
                class="svgTW"
                v-if="item.entrada=='TW'"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                focusable="false"
                width="30px"
                height="30px"
                preserveAspectRatio="xMidYMid meet"
                
                viewBox="0 0 4500 4500">
                <path d="M0 4579 c-2 -3 160 -224 359 -490 199 -266 622 -832 940 -1257 l578
        -773 -37 -42 c-21 -23 -446 -482 -944 -1020 -498 -539 -907 -983 -908 -988 -2
        -5 85 -9 210 -8 l213 1 70 77 c39 42 401 433 805 870 404 437 746 807 760 823
        l25 29 200 -268 c110 -147 413 -553 673 -901 l474 -632 725 0 c603 0 724 2
        720 13 -3 8 -187 256 -409 553 -222 296 -476 636 -564 754 -89 118 -350 469
        -582 778 -232 310 -422 568 -422 572 0 7 1226 1338 1643 1783 l119 127 -219 0
        -218 -1 -255 -276 c-140 -152 -483 -524 -763 -825 l-507 -548 -615 822 -616
        823 -725 5 c-399 3 -728 2 -730 -1z m1718 -886 c237 -318 603 -807 813 -1088
        210 -280 676 -904 1036 -1385 360 -482 658 -881 663 -888 6 -9 -65 -12 -324
        -12 l-331 0 -656 878 c-1514 2023 -2278 3045 -2287 3060 -6 9 62 12 323 12
        l331 0 432 -577z" />
            </svg>
            <svg
                class="svgYoutube"
                v-if="item.entrada=='Y'"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                focusable="false"
                width="30px"
                height="30px"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
            >
                <path
                    d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73z"
                />
            </svg>
            <svg
                class="svgInsta"
                v-if="item.entrada=='I'"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                focusable="false"
                width="30px"
                height="30px"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
            >
                <path
                d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3z"
                />
            </svg>
            <svg
                class="svgPD"
                v-if="item.entrada=='PD'"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                focusable="false"
                width="30px"
                height="30px"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
            >
                <path
                d="M20 6v12H4V6h16m2-2H2v14s0 2 2 2h16s2 0 2-2V4m-12 9H6V8h4v5m8 0h-7v-2h7v2m0-3h-7V8h7v2z"
                />
            </svg>
            <svg
                class="svgTV"
                v-if="item.entrada=='T'"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                width="30px"
                height="30px"
                viewBox="0 0 24 24"
            >
            <path
              d="M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9A1,1 0 0,1 20.5,10A1,1 0 0,1 19.5,11A1,1 0 0,1 18.5,10A1,1 0 0,1 19.5,9M19.5,12A1,1 0 0,1 20.5,13A1,1 0 0,1 19.5,14A1,1 0 0,1 18.5,13A1,1 0 0,1 19.5,12Z"
            />
          </svg>
          <svg
            class="svgRadio"
            v-if="item.entrada=='R'"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            aria-hidden="true"
            focusable="false"
            width="30px"
            height="30px"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.026 6.026 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10.005 10.005 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8z"
            />
          </svg>
        </span>
        <span class="hora" v-if="item.entrada == 'R' || item.entrada=='T'">
            {{getMXfecha(item.fecha)}} Dur. {{item.dur}} 
        </span>
        <span class="hora" v-else>{{getMXfecha(item.fecha)}}</span>
        <!--<div class="multimedia touchpad" v-if="item.thumb">
            <img class="oculto" :ref="'imagen_'+item.key" :src="item.thumb">
            <span class="titulo" v-if="item.entrada=='T' || item.entrada == 'R'" v-html="convertString(item.titulo)"></span>
            <span class="titulo" v-else v-html="item.titulo || item.descripcion.slice(0, 140) + '...'"></span>
        </div>-->
        <span class="titulo" v-if="item.titulo" v-html="item.titulo"  @click="goToNote(item)" ></span>
        <span class="titulo" v-else v-html="getDesc(item)"  @click="goToNote(item)" ></span>
        
    </div>

</template>

<script>
import moment from "moment-timezone";
export default {
    name:'linea',
    props:['defaultItem','from'],
    data() {
        return {
            url: this.$store.getters.getMainUrl,
            providerID: this.$store.state.userInfo.net,
            item:{},
            emptyNote:true
        }
    },
    computed:{
        token(){
            return this.$store.getters.getToken;
        }
    },
    beforeMount(){
        this.getItem();
    },
    methods:{
        getMXfecha(fecha){
            if(fecha){
            var tmp = moment(fecha,'YYYY-MM-DD HH:mm:ss');
            var f = moment
                .tz(tmp, "America/Mexico_City")
                // .utc()
                // .local()
                .format('DD/MM/YYYY HH:mm:ss');
            return f;
            }else{
                return '';
            }

        },
        getDesc(item){
            if(item.descripcion)
                return item.descripcion.slice(0, 140) + '...';
            else 
                return '';
        },
        getItem() {
            var post_data = {
                token: this.token,
                key: this.defaultItem.key,
                entrada: this.defaultItem.entrada,
                logs:true
            };
            var self = this;
            axios.post(this.url + "getNote", JSON.stringify(post_data)) //petición
            .then(response => {
                console.log('response getNote');
                console.log(response);
                if(response.data.success){ 
                   var db_item = response.data.data;
                    var note = {
                        key : db_item.key,
                        titulo: db_item.titulo,
                        fecha: db_item.publicado_utc,
                        thumb: db_item.thumb,
                        entrada: db_item.entrada,
                        descripcion:db_item.descripcion
                    }
                    if ( self.defaultItem.entrada == 'R' || self.defaultItem.entrada == 'T' ){
                        note.dur = db_item.descripcion? db_item.descripcion.duracion : '';
                        note.descripcion = '';
                    }
                    if (db_item.metadatos) {
                        var metadata_item = db_item.metadatos;
                        note.titulo = metadata_item.titulo ? metadata_item.titulo : note.titulo;
                        note.thumb = metadata_item.imagen? metadata_item.imagen:note.thumb;
                    }
                    self.item = note;
                    self.emptyNote = false;
                }else{
                    console.log('empty note');
                    console.log(self.defaultItem.key);
                   self.emptyNote = true;
                }
            }).catch(function(error) {
                var response = { success: false, error: error };
                console.log(error);
            });
            
            
        },
        goToNote(params) {
            this.$emit("goToNote", params);
        },
        borrar(){
            this.$emit('borrar',this.defaultItem);
        }
    }
}
</script>
<style scoped>
.deletebtn {
    border:none;
    color:#fff!important; 
    padding:5px 10px!important;
}

.button.tooltip:after {
  z-index: 9999999999;
}


</style>